import { MachineEventType } from "@enums/machineEventType.enum";
import { Model } from "@interfaces/model.interface";
import { Guid } from "guid-typescript";

export interface MachineEvent extends Model {
	appointmentDate? : Date;
	bookingConfirmed: boolean;
	completed: boolean;
	costApproved: boolean;
	description: string;
	downtimeCost: number;
	downtimeHours: number;
	eventDate: Date;
	eventImageUrl: string;
	eventType: MachineEventType;
	machineId: number;
	thirdPartyReportLookupId?: Guid;
}

export class MachineEvent implements MachineEvent {
	eventDate = new Date;
	eventType = MachineEventType.Service;

	constructor(data?: Partial<MachineEvent>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}